<template>
  <div :id="id" class="echarts" />
</template>

<script>
export default {
  name: '',
  components: {

  },
  mixins: [

  ],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default:0
    }
  },
  data() {
    return {
      id: `echarts${Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)}`,
      myEchart: null
    }
  },
  computed: {

  },
  watch: {
    data: {
      handler: function() {
        this.dram()
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(function() {
      this.dram()
    })
  },
  methods: {
    dram() {
      var _this = this
      if (this.myEchart != null && this.myEchart !== '' && this.myEchart !== undefined) {
        this.myEchart.dispose()// 销毁
      }
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show:false,
          orient: 'horizontal',
          bottom: 'bottom',
          icon: 'circle',
          itemHeight: 6,
          itemWidth: 6,
          textStyle: {
            fontSize: 10,
            color: '#90979B'
          }
        },
        color: ['#5C7EFF', '#EEF2FF'],
        series: [
          {
            name: '内存使用率',
            type: 'pie',
            radius: ['40%', '55%'],
            label: {
              normal: {
                show: true, // 是否显示标签[ default: false ]
                position: 'outside', // 标签的位置。'outside'饼图扇区外侧，通过视觉引导线连到相应的扇区。'inside','inner' 同 'inside',饼图扇区内部。'center'在饼图中心位置。
                formatter: function(params) {
                  return (
                    `{c|${params.name}}`+ `{d|${params.value}G}`
                  )
                },
                textStyle: {
                  fontSize: 10,
                  color: '#8DCDD0'
                },
                rich: {
                  c: {
                    color: '#34446E',
                    fontSize: 12,
                    align: 'left',
                    padding: [10, 0]
                  },
                  d: {
                    color: '#5C7EFF',
                    align: 'left',
                    fontSize: 12
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: function(params) {
                    // 自定义颜色
                    var colorList = ['#5C7EFF', '#EEF2FF']
                    return colorList[params.dataIndex]
                  }
                }
              }
            },
            labelLine: {
              // 标签的视觉引导线样式,在 label 位置 设置为'outside'的时候会显示视觉引导线。
              normal: {
                show: true, // 是否显示视觉引导线。
                length: 20, // 在 label 位置 设置为'outside'的时候会显示视觉引导线。
                length2: 40, // 视觉引导项第二段的长度。
                lineStyle: {
                  // 视觉引导线的样式
                  // color: '#000',
                  // width: 1
                }
              }
            },
            data: this.data
          },
          {
            name: '',
            type: 'pie',
            radius: ['30%', '30%'],
            itemStyle: {
              borderRadius: 10
            },
            tooltip: {
              show: false
            },
            label: {
              normal: {
                show: true, // 是否显示标签[ default: false ]
                position: 'center', // 标签的位置。'outside'饼
                formatter: function(params) {
                  return (
                    `{c|${params.name}}` + '\n'+ `{d|${params.value}G}`
                  )
                },
                rich: {
                  c: {
                    color: '#34446E',
                    fontSize: 12,
                    align: 'center',
                    padding: [10, 0]
                  },
                  d: {
                    color: '#19213F',
                    align: 'center',
                    fontSize: 20
                  }
                }
              }
            },
            hoverAnimation: false,
            labelLine: {
              // 标签的视觉引导线样式,在 label 位置 设置为'outside'的时候会显示视觉引导线。
              normal: {
                show: false, // 是否显示视觉引导线。
                length: 18, // 在 label 位置 设置为'outside'的时候会显示视觉引导线。
                length2: 60, // 视觉引导项第二段的长度。
                lineStyle: {
                  // 视觉引导线的样式
                  type: 'dashed'
                  // color: '#000',
                  // width: 1
                }
              }
            },
            data: [{ value: this.total, name: '总容量' }]
          },
        ]
      }
      this.myEchart = this.$echarts.init(document.getElementById(this.id))
      this.myEchart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.myEchart.resize()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.echarts{
  width: 100%;
  height: 100%;
}
</style>
